import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-说明",
  "use": "icon-说明-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-说明\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 128H256A128 128 0 0 0 128 256v512A128 128 0 0 0 256 896h512a128 128 0 0 0 128-128V256A128 128 0 0 0 768 128zM844.8 768a76.8 76.8 0 0 1-76.8 76.8H256A76.8 76.8 0 0 1 179.2 768V256A76.8 76.8 0 0 1 256 179.2h512A76.8 76.8 0 0 1 844.8 256z\" fill=\"\" p-id=\"968\" /><path d=\"M716.8 321.536H307.2a25.6 25.6 0 0 0 0 51.2h409.6a25.6 25.6 0 0 0 0-51.2zM307.2 541.184h204.8a25.6 25.6 0 0 0 0-51.2H307.2a25.6 25.6 0 0 0 0 51.2zM716.8 658.432H307.2a25.6 25.6 0 1 0 0 51.2h409.6a25.6 25.6 0 0 0 0-51.2z\" fill=\"\" p-id=\"969\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/说明.svg
// module id = Mu4j
// module chunks = 75